'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { useBreakpoint } from '@insta-club/hooks';
import { Course, CourseResponse } from '@insta-club/models';
import { CourseItem } from 'src/libs/components/common';
import ContentWrapper from 'src/libs/components/common/contentWrapper';
import { Container } from 'src/libs/components/layout';
import { Swiper, SwiperSlide } from 'swiper/react';
import useSWR from 'swr';

type SwiperSettings = {
    slidesPerView: number;
    spaceBetween: number;
};

const breakpoints: Record<number, SwiperSettings> = {
    0: { slidesPerView: 1.05, spaceBetween: 10 },
    540: { slidesPerView: 1.1, spaceBetween: 10 }
};

function LatestCourse() {
    const activeBreakpoints = useBreakpoint<SwiperSettings>(breakpoints);

    const { isLoading, data } = useSWR<CourseResponse>(ApiKeys.COURSES, (url: string) =>
        fetcher(url, 'dashboard', 'GET')
    );

    const lastCourse = data?.data?.at(-1);

    return (
        <>
            {isLoading ? (
                <ContentWrapper
                    title='جدیدترین دوره آموزشی'
                    link={{
                        title: 'نمایش همه',
                        href: '/courses'
                    }}
                >
                    <Swiper
                        slidesPerView={activeBreakpoints.slidesPerView}
                        spaceBetween={activeBreakpoints.spaceBetween}
                        slidesOffsetBefore={24}
                        slidesOffsetAfter={24}
                    >
                        {Array.from({ length: 3 }, (_, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className='relative aspect-video h-full w-full animate-pulse overflow-hidden rounded-2xl bg-gray-100'>
                                        <div className='absolute inset-0 z-[1] flex flex-col items-start justify-between'>
                                            <div className='m-2 flex items-center gap-2 self-end rounded-[18px] bg-gray-300 p-1 pl-2 backdrop-blur-xs'>
                                                <div className='h-7 w-7 rounded-full bg-gray-200' />
                                                <div className='h-2 w-8 rounded bg-gray-200' />
                                            </div>
                                            <div className='flex w-full flex-col items-start gap-2 p-3'>
                                                <div className='h-2 w-28 rounded bg-gray-200' />
                                                <div className='flex w-full items-center justify-between'>
                                                    <div className='flex items-center gap-2 rounded-lg bg-gray-300 p-1.5 text-xs text-gray-200'>
                                                        <div className='h-4 w-4 rounded-full bg-gray-200' />
                                                        <div className='h-2 w-8 rounded bg-gray-200' />
                                                    </div>
                                                    <div className='h-6 w-16 rounded bg-gray-200' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </ContentWrapper>
            ) : data?.data?.length ? (
                !!data?.data.length && (
                    <>
                        <ContentWrapper
                            title='جدیدترین دوره آموزشی'
                            link={{
                                title: 'نمایش همه',
                                href: '/courses'
                            }}
                        >
                            {lastCourse && (
                                <Container>
                                    <CourseItem course={lastCourse} />
                                </Container>
                            )}

                            <Swiper
                                slidesPerView={activeBreakpoints.slidesPerView}
                                spaceBetween={activeBreakpoints.spaceBetween}
                                slidesOffsetBefore={24}
                                slidesOffsetAfter={24}
                                className='mt-4'
                            >
                                {data?.data?.slice(0, 3).map((course: Course) => {
                                    return (
                                        <SwiperSlide key={course.id}>
                                            <CourseItem course={course} />
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </ContentWrapper>
                    </>
                )
            ) : null}
        </>
    );
}

export default LatestCourse;

